import classnames from 'classnames';
import React from 'react';

import { ZonedDate } from '@eika-infrastruktur/date';

import { CalendarDate, CalendarDateDetail } from '../types';

export interface CalendarDateButtonBoxProps {
    detail: CalendarDateDetail;
}

const CalendarDateButtonBox = ({ detail }: CalendarDateButtonBoxProps): JSX.Element => (
    <>
        <span aria-hidden="true" className="sgw-calendar__view-info__full_text">
            {`${detail.weekNameText} `}
            <strong>{`${detail.date}. `}</strong>
            {`${detail.monthNameText}`}
        </span>
        <span aria-hidden="true" className="sgw-calendar__view-info__short_text">
            {`${detail.weekShortnameText} ${detail.dateText}.${detail.monthText}`}
        </span>
    </>
);

export interface CalendarDateButtonProps {
    data: CalendarDate;
    onSelect: (v: ZonedDate) => void;
    box?: boolean;
    bankHoliday?: boolean;
}

const CalendarDateButton = ({ data, onSelect, box, bankHoliday = false }: CalendarDateButtonProps): JSX.Element => {
    const style = classnames('sgw-calendar__view-info', box ? '-box' : '-cell', {
        '-disabled': data.disabled,
        '-week-end': data.weekEnd || bankHoliday,
        '-today': data.today,
        '-selected': data.selected,
        '-out-of-month': data.outOfMonth,
    });

    const attributes = {
        'aria-selected': data.selected,
        'aria-disabled': data.disabled,
        'aria-label': data.aria,
    };

    const btnAttr = {
        tabIndex: data.selected || box || data.focusable ? 0 : -1,
        'data-date-in-focus': data.focus,
    };

    return data.disabled ? (
        <div {...attributes} className={style}>
            {box ? <CalendarDateButtonBox detail={data.detail} /> : <span aria-hidden="true">{data.text}</span>}
        </div>
    ) : (
        <button
            {...attributes}
            {...btnAttr}
            type="button"
            className={style}
            onClick={() => {
                onSelect(data.zonedDate);
            }}
            ref={data.buttonref}
            onFocus={data.onFocus}
        >
            {box ? <CalendarDateButtonBox detail={data.detail} /> : <span aria-hidden="true">{data.text}</span>}
        </button>
    );
};

export default CalendarDateButton;
